import {
  eliminarSuscripcionPush,
  guardarSuscripcionPush,
  obtenerClavePublicaPush,
} from './api';

const convertirClavePublica = (clave) => {
  const base64 = clave.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  const binary = window.atob(padded);
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
};

const obtenerRegistroServiceWorker = async () => {
  if (!window.isSecureContext) {
    throw new Error('Las notificaciones push requieren HTTPS (o localhost para pruebas).');
  }
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    throw new Error('Este navegador no admite notificaciones push.');
  }

  const workerPath = `${process.env.PUBLIC_URL || ''}/service-worker.js`.replace(/\/{2,}/g, '/');
  const workerUrl = new URL(workerPath, window.location.origin);
  await navigator.serviceWorker.register(workerUrl.href);
  return navigator.serviceWorker.ready;
};

export const activarNotificacionesPush = async () => {
  if (!window.isSecureContext) {
    throw new Error('Las notificaciones push requieren HTTPS (o localhost para pruebas).');
  }
  if (!('Notification' in window)) {
    throw new Error('Este navegador no admite notificaciones push.');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Permite las notificaciones en el navegador para recibir avisos.');
  }

  const configuracion = await obtenerClavePublicaPush();
  if (!configuracion.exito || !configuracion.clave_publica) {
    throw new Error(configuracion.mensaje || 'El servidor no tiene configuradas las notificaciones push.');
  }

  const registration = await obtenerRegistroServiceWorker();
  const subscription = await registration.pushManager.getSubscription()
    || await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertirClavePublica(configuracion.clave_publica),
    });
  const respuesta = await guardarSuscripcionPush(subscription.toJSON());
  if (!respuesta.exito) {
    throw new Error(respuesta.mensaje || 'No se pudo guardar la suscripción push.');
  }
  return subscription;
};

export const desactivarNotificacionesPush = async () => {
  const registration = await obtenerRegistroServiceWorker();
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;

  const respuesta = await eliminarSuscripcionPush(subscription.toJSON());
  if (!respuesta.exito) {
    throw new Error(respuesta.mensaje || 'No se pudo eliminar la suscripción push.');
  }
  await subscription.unsubscribe();
};

export const tieneSuscripcionPush = async () => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  const registration = await navigator.serviceWorker.getRegistration();
  return Boolean(await registration?.pushManager.getSubscription());
};
